import React from 'react';
import { FormattedMessage } from 'react-intl';

export default ({
  input,
  label,
  type,
  style,
  placeholder,
  disabled,
  forceEdit = false,
  meta: { touched, error, warning, initial, dirty },
}) => {
  let _disabled;
  forceEdit ? (_disabled = false) : (_disabled = initial && !dirty);

  return (
    <div className="col-md-9">
      <div className="md-form">
        <input
          {...input}
          placeholder={placeholder}
          type={type}
          style={style}
          className={(touched && error && 'input-error') || undefined}
          disabled={disabled || _disabled}
        />
        {touched && error && error !== 'required' && (
          <span style={{ color: 'red', marginTop: 5 }}>
            <FormattedMessage {...error} />
          </span>
        )}
      </div>
    </div>
  );
};

export const Input = ({
  input,
  label,
  type = 'text',
  style,
  placeholder,
  forceEdit = false,
  className = '',
  noRow,
  meta: { touched, error, initial, dirty },
  ...custom
}) => {
  let disabled;
  forceEdit ? (disabled = false) : (disabled = initial && !dirty);

  return (
    <div className={`${className} ${noRow ? '' : 'align-items-end'}`}>
      <label className="mr-1">{label}</label>

      <input
        {...input}
        {...custom}
        placeholder={placeholder}
        type={type}
        style={style}
        className={(touched && error && 'input-error') || undefined}
        disabled={disabled}
      />
      {touched && error && error !== 'required' && (
        <span style={{ color: 'red', marginTop: 5 }}>
          <FormattedMessage {...error} />
        </span>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/application-form/field-components/input.js